// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"94a2dd66","193":"276e40aa","214":"86db0109","361":"756f46b0","384":"b526ce60","489":"cee5e18a","626":"1d5c2502","844":"4c8226fd","979":"edc655d6"}[chunkId] + ".css";
};